/**
 * XMLHttp client.
 */

module.exports = function (_) {

    var Promise = require('../promise')(_);

    return function (request) {
        return new Promise(function (resolve) {

            var xhr = new XMLHttpRequest(), response = {request: request}, handler;

            request.cancel = function () {
                xhr.abort();
            };

            xhr.open(request.method, _.url(request), true);

            if (_.isPlainObject(request.xhr)) {
                _.extend(xhr, request.xhr);
            }

            _.each(request.headers || {}, function (value, header) {
                xhr.setRequestHeader(header, value);
            });

            handler = function (event) {

                response.data = xhr.responseText;
                response.status = xhr.status;
                response.statusText = xhr.statusText;
                response.headers = getHeaders(xhr);

                resolve(response);
            };

            xhr.onload = handler;
            xhr.onabort = handler;
            xhr.onerror = handler;

            xhr.send(request.data);
        });
    };

    function getHeaders(xhr) {

        var headers;

        if (!headers) {
            headers = parseHeaders(xhr.getAllResponseHeaders());
        }

        return function (name) {

            if (name) {
                return headers[_.toLower(name)];
            }

            return headers;
        };
    }

    function parseHeaders(str) {

        var headers = {}, value, name, i;

        if (_.isString(str)) {
            _.each(str.split('\n'), function (row) {

                i = row.indexOf(':');
                name = _.trim(_.toLower(row.slice(0, i)));
                value = _.trim(row.slice(i + 1));

                if (headers[name]) {

                    if (_.isArray(headers[name])) {
                        headers[name].push(value);
                    } else {
                        headers[name] = [headers[name], value];
                    }

                } else {

                    headers[name] = value;
                }

            });
        }

        return headers;
    }

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/client/xhr.js
// module id = 222
// module chunks = 1